/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'
import { apiResponseV4Schema } from './apiResponseV4Schema'
import { inviteAnswerRequestV4Schema } from './inviteAnswerRequestV4Schema'
import { switchOrgResponseV4ApiResponseObjectV4Schema } from './switchOrgResponseV4ApiResponseObjectV4Schema'

export const meAcceptInviteStatus200Schema = switchOrgResponseV4ApiResponseObjectV4Schema.describe(
  'Typed variant of EP.Models.ViewModels.ApiResponseObjectV4, used in `[ProducesResponseType]` so Swagger renders\r\nthe real `result` schema instead of the bare `object` (which the UI shows as `"string"`).\r\nWire shape is identical to the untyped envelope — this only carries the type for the schema generator.'
)

export const meAcceptInviteStatus400Schema = apiResponseV4Schema.describe(
  'V4 response envelope — same contract as the legacy EP.Models.ViewModels.ApiResponse minus the dead\r\n`planNeeded` field. V4 endpoints must never expose `planNeeded`; legacy endpoints keep\r\nthe old envelope untouched.'
)

export const meAcceptInviteResponseSchema = meAcceptInviteStatus200Schema

export const meAcceptInviteErrorSchema = meAcceptInviteStatus400Schema

export const meAcceptInviteBodySchemaJsonPatchJson = inviteAnswerRequestV4Schema
  .optional()
  .describe('Coded id of the invitation being accepted (from the AcceptOrgInvite event).')

export const meAcceptInviteBodySchemaJson = inviteAnswerRequestV4Schema
  .optional()
  .describe('Coded id of the invitation being accepted (from the AcceptOrgInvite event).')

export const meAcceptInviteBodySchemaJson2 = inviteAnswerRequestV4Schema
  .optional()
  .describe('Coded id of the invitation being accepted (from the AcceptOrgInvite event).')

export const meAcceptInviteBodySchemaJson3 = inviteAnswerRequestV4Schema
  .optional()
  .describe('Coded id of the invitation being accepted (from the AcceptOrgInvite event).')

export const meAcceptInviteBodySchema = z.union([
  meAcceptInviteBodySchemaJsonPatchJson,
  meAcceptInviteBodySchemaJson,
  meAcceptInviteBodySchemaJson2,
  meAcceptInviteBodySchemaJson3,
])
